// extracted by mini-css-extract-plugin
export default {"root":"truncText_root__mS53D","truncate":"truncText_truncate__-c2vY"};